import React, { useRef, useEffect } from 'react';
import { RadioButton } from 'primereact/radiobutton';
import CustomInputText from '../../../../components/common/CustomInputText';
import { Text } from '../../../../components/Text';
import { wcaHeaderTypes, wcaMediaTypes } from '../../../../utils/templateUtils';

const TemplateHeader = ({
  control,
  watch,
  setValue,
  file,
  setFile,
  previewFile,
  validateMediaSize,
  getFormErrorMessage,
  setImagePreview = () => {},
  setVideoPreview = () => {},
  setDocumentPreview = () => {},
}) => {
  const mediaFileRef = useRef(null);

  const watchHeaderType = watch('headerType');
  const watchMediaType = watch('mediaType');

  useEffect(() => {
    setFile(null);
    setImagePreview(null);
    setVideoPreview(null);
    setDocumentPreview(null);
  }, [watchMediaType]);

  const handleDeleteMedia = () => {
    setFile(null);
  };

  const mediaSelect = (icon, accept) => {
    let isValid = true;
    let acceptedSize = '';

    if (file) {
      const result = validateMediaSize(file.size, watchMediaType?.toLowerCase());
      isValid = result.isValid;
      acceptedSize = result.acceptedSize;
    }

    return !file ? (
      <div className="field">
        <input ref={mediaFileRef} type="file" accept={accept} hidden onChange={previewFile} />

        <button
          type="button"
          className="w-full temp-img flex gap-3 p-3 my-2 cursor-pointer"
          onClick={() => mediaFileRef.current.click()}
        >
          <i className={`pi ${icon}`} />
          <Text type={'sub-heading'}>Choose {watchMediaType?.toLowerCase()}</Text>
        </button>
      </div>
    ) : (
      <>
        <div className="temp-img-upload">
          <div className="flex gap-2 justify-content-between align-items-center">
            <div className="flex gap-2 align-items-center">
              <i className={`pi ${icon}`} />
              <Text type={'sub-heading'}>{file.name}</Text>
            </div>

            <i className="pi pi-trash cursor-pointer" onClick={handleDeleteMedia} />
          </div>
        </div>

        {!isValid && (
          <div className="mb-2">
            <small className="p-error">
              {watchMediaType?.toLowerCase()} size should be less than {acceptedSize} MB.
            </small>
          </div>
        )}
      </>
    );
  };

  const renderHeaderContent = () => {
    switch (watchHeaderType) {
      case 'NONE':
        return null;

      case 'TEXT':
        return (
          <div className="w-full">
            <CustomInputText
              name="header"
              label="Header Text"
              control={control}
              placeholer="Enter Header Text"
              maxLength={60}
            />
            {getFormErrorMessage('header')}
          </div>
        );

      case 'MEDIA':
        return (
          <>
            <div className="flex flex-row flex-wrap gap-3 mb-3">
              {wcaMediaTypes.map((type) => (
                <div key={type.value} className="flex align-items-center">
                  <RadioButton
                    inputId={type.value}
                    name="mediaType"
                    value={type.value}
                    onChange={(e) => setValue('mediaType', e.value)}
                    checked={watchMediaType === type.value}
                  />

                  <label htmlFor={type.value} className="ml-2">
                    {type.key}
                  </label>
                </div>
              ))}
            </div>

            {watchMediaType &&
              mediaSelect(
                wcaMediaTypes.find((m) => m.value === watchMediaType)?.icon,
                wcaMediaTypes.find((m) => m.value === watchMediaType)?.accept,
              )}
          </>
        );

      case 'LOCATION':
        return (
          <div className="p-3 border-round border-1 surface-border">
            <div className="flex align-items-center gap-2">
              <i className="pi pi-map-marker text-red-500" />
              <b>Location</b>
            </div>

            <small>A map pin appears at the top. Coordinates are set at send time.</small>
          </div>
        );

      default:
        return null;
    }
  };

  return (
    <div className="w-full">
      <label>Header Type *</label>

      <div className="w-full flex flex-row flex-wrap gap-3 mt-3">
        {wcaHeaderTypes.map((type) => (
          <div key={type.value} className="flex align-items-center">
            <RadioButton
              inputId={type.value}
              name="headerType"
              value={type.value}
              onChange={(e) => setValue('headerType', e.value)}
              checked={watchHeaderType === type.value}
            />

            <label htmlFor={type.value} className="ml-2">
              {type.key}
            </label>
          </div>
        ))}
      </div>

      <div className="mt-3">{renderHeaderContent()}</div>
    </div>
  );
};

export default TemplateHeader;
